import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M30.97 6.16c-.26-.74-1.06-2.9-3.24-4.35A7.4 7.4 0 0 0 25.18.72c-1.62-.35-2.91-.04-3.48.1-.56.14-1.88.48-3.12 1.57-.75.65-1.19 1.33-1.46 1.75-.6.93-.93 1.8-1.11 2.44-.19-.64-.52-1.51-1.11-2.44-.27-.42-.71-1.09-1.46-1.75C12.19 1.31 10.88.96 10.32.82S8.46.37 6.84.72c-.35.06-1.41.32-2.57 1.08-2.18 1.46-2.98 3.61-3.24 4.36-.1.3-.6 1.74-.52 3.7.07 1.79.59 3.09.89 3.81.98 2.4 2.52 4.03 4.05 5.65.07.07.05.05.94.96 1.77 1.79 3.96 4.02 4.39 4.46 1.23 1.27 2.99 3.31 5.17 6.63.02.03.03.05.05.08.02-.03.03-.05.05-.08 2.18-3.32 3.94-5.36 5.17-6.63.43-.44 2.63-2.68 4.39-4.46.9-.91.88-.89.94-.96 1.53-1.62 3.06-3.25 4.05-5.65.3-.72.81-2.02.89-3.81.08-1.96-.41-3.41-.52-3.7" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }